import type { ClientTerritorialAuthority } from '@DigitaleDoerfer/digitale-doerfer-api';
import { ClientTerritorialAuthorityTypeEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

import { GrussVomBuergerMeisterCard } from '@/features/start/components/header/GrussVomBuergerMeisterCard';

export const useGrussVomBuergerMeisterCard = (
  territorialAuthority?: ClientTerritorialAuthority
) => {
  const mayorGreeting =
    territorialAuthority?.type ===
    ClientTerritorialAuthorityTypeEnum.Organization
      ? territorialAuthority.territorialAuthority?.mayorGreeting?.trim()
      : undefined;

  if (!mayorGreeting) {
    return;
  }

  return <GrussVomBuergerMeisterCard mayorGreeting={mayorGreeting} />;
};
